(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["article"]) return;
  try {
    
(function() {
  var content = document.getElementById('article-content');

  if (!content) return;

  // Find all H2 headings in the content
  var headings = content.querySelectorAll('h2');

  if (headings.length === 0) return;

  // Ensure headings have IDs (useful for anchors/other scripts)
  headings.forEach(function(heading, index) {
    if (!heading.id) {
      heading.id = 'heading-' + index;
    }
  });

  // Inject inline CTA before 4th H2 heading
  var inlineCtaContent = document.getElementById('inline-cta-content');

  if (inlineCtaContent && headings.length >= 4) {
    var fourthH2 = headings[3]; // 0-based index → 4th heading
    var ctaClone = inlineCtaContent.cloneNode(true);
    ctaClone.id = 'inline-cta-injected';
    ctaClone.style.display = 'block';

    fourthH2.parentNode.insertBefore(ctaClone, fourthH2);
  }
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog"]) return;
  try {
    
(function() {
  var loadMoreButton = document.querySelector('.blog__load-more-button');
  if (!loadMoreButton) return;

  loadMoreButton.addEventListener('click', function() {
    var nextUrl = this.getAttribute('data-next-url');
    var showExcerpt = this.getAttribute('data-show-excerpt') === 'true';
    var showDate = this.getAttribute('data-show-date') === 'true';

    if (!nextUrl) return;

    // Show loading state
    this.disabled = true;
    var textSpan = this.querySelector('.blog__load-more-text');
    var spinnerSpan = this.querySelector('.blog__load-more-spinner');
    textSpan.style.display = 'none';
    spinnerSpan.style.display = 'inline-flex';

    // Fetch next page
    fetch(nextUrl)
      .then(function(response) {
        return response.text();
      })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');

        // Get new articles
        var newArticles = doc.querySelectorAll('#blog-grid .blog-card');
        var grid = document.getElementById('blog-grid');

        // Append new articles
        newArticles.forEach(function(article) {
          grid.appendChild(article.cloneNode(true));
        });

        // Update or remove button
        var newButton = doc.querySelector('.blog__load-more-button');
        if (newButton && newButton.getAttribute('data-next-url')) {
          loadMoreButton.setAttribute('data-next-url', newButton.getAttribute('data-next-url'));
          loadMoreButton.disabled = false;
          textSpan.style.display = '';
          spinnerSpan.style.display = 'none';
        } else {
          // No more pages, remove button
          loadMoreButton.closest('.blog__load-more').remove();
        }
      })
      .catch(function(error) {
        console.error('Error loading more articles:', error);
        loadMoreButton.disabled = false;
        textSpan.style.display = '';
        spinnerSpan.style.display = 'none';
        textSpan.textContent = 'Error loading articles';
      });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
